import { render } from "./PreloaderComponent.vue?vue&type=template&id=dc354818"
import script from "./PreloaderComponent.vue?vue&type=script&lang=js"
export * from "./PreloaderComponent.vue?vue&type=script&lang=js"

import "./PreloaderComponent.vue?vue&type=style&index=0&id=dc354818&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__